// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folders';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.967 9.567a1.133 1.133 0 0 0-1.134-1.134h-6.8l-.8-.801A1.133 1.133 0 0 0 3.43 7.3H1.633A1.133 1.133 0 0 0 .5 8.433v7.934A1.133 1.133 0 0 0 1.633 17.5h10.2a1.133 1.133 0 0 0 1.134-1.133z' />
    <path d='M15.233 12.967v-6.8A1.133 1.133 0 0 0 14.1 5.033H7.3l-.8-.801a1.134 1.134 0 0 0-.802-.332H3.9a1.135 1.135 0 0 0-1.133 1.133' />
    <path d='M17.5 9.567v-6.8a1.133 1.133 0 0 0-1.133-1.134h-6.8L8.766.832A1.133 1.133 0 0 0 7.964.5H6.167a1.133 1.133 0 0 0-1.134 1.133' />
  </g>
);

export const viewBox = '0 0 18 18';
